import React from "react";
import { Link } from "redux-little-router";
import { checkIfMobile } from "../../../../util";
import "./index.css";

const CollectionCard = ({ collection }) => {
  const { name, postsCount, _id, slug = "", gradientColor = { from: "#00a4e8", to: "#61dd9f" } } = collection;
  const isMobile = checkIfMobile();
  const gradientStyle = {
    borderImage: `linear-gradient(to ${isMobile ? "right" : "top"}, ${gradientColor.from}, ${gradientColor.to}) 1 ${
      isMobile ? "0%" : "100%"
    }`,
  };
  return (
    <Link href={`/collections/${_id}/${slug}`}>
      <div style={gradientStyle} className="collection-card">
        <div className="content-container">
          <h4 className="-name">{name}</h4>
          <p className="-count">{`${postsCount} cases`}</p>
        </div>
      </div>
    </Link>
  );
};

export default CollectionCard;



// WEBPACK FOOTER //
// ./src/scenes/CollectionsPage/components/CollectionCard/index.js